class CollectionSlider extends HTMLElement {
  constructor() {
    super();
    this.flickityInstance = null;
    this.init();
  }

  init() {
    this.initSlider();
    this.handleResize = this.handleResize.bind(this);
    window.addEventListener('resize', this.handleResize);
  }

  initSlider() {
    const collectionSlider = this.querySelector('[data-collection-slider]');
    if (!collectionSlider) return;

    this.flickityInstance = new Flickity(collectionSlider, {
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      prevNextButtons: true,
      wrapAround: false,
      adaptiveHeight: false,
      cellSelector: '.collection-slider__slide',
      groupCells: true
    });

    equalizeSlideHeights(this.flickityInstance);
    window.addEventListener('load', () => equalizeSlideHeights(this.flickityInstance));
  }

  handleResize() {
    if (this.flickityInstance) {
      equalizeSlideHeights(this.flickityInstance);
    }
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('load', () => equalizeSlideHeights(this.flickityInstance));
    if (this.flickityInstance) {
      this.flickityInstance.destroy();
    }
  }
}

customElements.define('collection-slider', CollectionSlider); 